import facepaint from "facepaint";

export default facepaint([
  "@media (min-width: 30em)",
  "@media (min-width: 48em)",
  "@media (min-width: 62em)",
  "@media (min-width: 76.5em)",
]);
